// src/apiConfig.js
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://gamestar24.com' ;
export default API_BASE_URL;
